import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ITechnicalRoom, ITechnicalRoomHistory } from './interfaces';

export const getTechnicalRoomList = (realEstateId: string) => (params: IDynamicTableParams) => {
  return instance(true, PPR_API_URL)
    .get<ITechnicalRoom[]>('/dictionary/technicalRoom/list/' + realEstateId, {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

export const getTechnicalRoomListAll = (realEstateId?: string) => {
  return instance(true, PPR_API_URL)
    .get<ITechnicalRoom[]>('/dictionary/technicalRoom/listAll' + realEstateId)
    .then((response) => response.data);
};

export const getTechnicalRoomAvailableColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableColumnModel[]>('/dictionary/technicalRoom/availableColumns')
    .then((response) => response.data);
};

export const getTechnicalRoomAvailableGroupColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableGroupColumnModel[]>('/dictionary/technicalRoom/availableGroupColumns')
    .then((response) => response.data);
};

export const loadTechnicalRoom = (technicalRoomId: number) => {
  return instance(true, PPR_API_URL)
    .get<ITechnicalRoom>('/dictionary/technicalRoom/load/' + technicalRoomId)
    .then((response) => response.data);
};

export const loadTechnicalRoomHistoryList = (technicalRoomId: number) => {
  return instance(true, PPR_API_URL)
    .get<ITechnicalRoomHistory[]>('/dictionary/technicalRoom/list/history/' + technicalRoomId)
    .then((response) => response.data);
};

export const loadTechnicalRoomHistoryItem = (technicalRoomId: number) => {
  return instance(true, PPR_API_URL)
    .get<ITechnicalRoomHistory>('/dictionary/technicalRoom/load/history/' + technicalRoomId)
    .then((response) => response.data);
};

export const createTechnicalRoom = (technicalRoom: ITechnicalRoom) => {
  return instance(true, PPR_API_URL)
    .post<ITechnicalRoom>('/dictionary/technicalRoom/create', technicalRoom)
    .then((response) => response.data);
};

export const updateTechnicalRoom = (technicalRoomId: number, technicalRoom: ITechnicalRoom) => {
  return instance(true, PPR_API_URL)
    .post<ITechnicalRoom>('/dictionary/technicalRoom/update/' + technicalRoomId, technicalRoom)
    .then((response) => response.data);
};

export const archiveTechnicalRoom = (technicalRoomId: number, isDeleted: boolean) => {
  return instance(true, PPR_API_URL)
    .post('/dictionary/technicalRoom/deleted/' + technicalRoomId, { isDeleted })
    .then((response) => response.data);
};
